/**
 * How to discover the app path(s).
 *
 * - If `cwd` contains a `cloudpack.config.json` (and `--app` is not set), that will be
 *   the only app path.
 * - Otherwise, glob for `cloudpack.config.json` under `cwd` (filtering by `--app` if set), then:
 *   - If `discover: 'multi'`, return all apps found.
 *   - If `discover: 'single'`:
 *     - If a single app is found, return that.
 *     - If multiple apps are found, prompt the user to choose one.
 *   - If `discover: 'remote'`, the app will be discovered from the cloud.
 * - If nothing is found, use `cwd` (unless `--app` is set and the name doesn't match).
 */
export type AppPathDiscoveryMode = 'single' | 'multi' | 'remote';
